import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <h1>404 - Страница не найдена</h1>
            <p>Запрошенная страница не существует или была перемещена.</p>
            <Link to="/" className="btn-primary cta-button" style={{ display: 'inline-block', marginTop: '20px' }}>
                Вернуться на главную
            </Link>
        </div>
    );
};

export default NotFoundPage;